import { lazy } from "react";

export const WorkforceDashboardsPage = lazy(() =>
  import("../views/workforce/WorkforceDashboardsPage").then((m) => ({
    default: m.WorkforceDashboardsPage,
  })),
);

export const WorkforceReportsPage = lazy(() =>
  import("../views/workforce/WorkforceReportsPage").then((m) => ({
    default: m.WorkforceReportsPage,
  })),
);

export const ApplicationAccessPage = lazy(() =>
  import("../views/workforce/ApplicationAccessPage").then((m) => ({
    default: m.ApplicationAccessPage,
  })),
);

export const ApplicationsPage = lazy(() =>
  import("../views/workforce/ApplicationsPage").then((m) => ({ default: m.ApplicationsPage })),
);

export const LifecyclePage = lazy(() =>
  import("../views/workforce/LifecyclePage").then((m) => ({
    default: m.LifecyclePage,
  })),
);

export const AssetsPage = lazy(() =>
  import("../views/workforce/assets/AssetsPage").then((m) => ({
    default: m.AssetsPage,
  })),
);

// Operational Licenses route: definitions read-only (managed in Settings), but
// seat grant/revoke stays available here for day-to-day use.
export const LicensesPage = lazy(() =>
  import("../views/workforce/licenses/LicensesPage").then((m) => ({
    default: m.LicensesRegisterPage,
  })),
);

export const SetupPage = lazy(() =>
  import("../views/workforce/SetupPage").then((m) => ({ default: m.SetupPage })),
);

export const WorkforceSettingsLayout = lazy(() =>
  import("../views/workforce/settings/WorkforceSettingsLayout").then((m) => ({
    default: m.WorkforceSettingsLayout,
  })),
);

export const PersonProfilePage = lazy(() =>
  import("../views/workforce/PersonProfilePage").then((m) => ({
    default: m.PersonProfilePage,
  })),
);

export const WorkforcePeoplePage = lazy(() =>
  import("../views/workforce/WorkforcePeoplePage").then((m) => ({
    default: m.WorkforcePeoplePage,
  })),
);
export const WorkforceAccessPage = lazy(() =>
  import("../views/workforce/WorkforceAccessPage").then((m) => ({
    default: m.WorkforceAccessPage,
  })),
);
export const WorkforceAssetsHubPage = lazy(() =>
  import("../views/workforce/WorkforceAssetsPage").then((m) => ({
    default: m.WorkforceAssetsPage,
  })),
);

export const OrgChartPage = lazy(() =>
  import("../views/workforce/OrgChartPage").then((m) => ({
    default: m.OrgChartPage,
  })),
);
